import { Smartphone, Sparkles } from "lucide-react";
import PageLayout from "../components/site/PageLayout";
import { Reveal } from "../components/site/Reveal";
import { SectionHeading } from "../components/site/SectionHeading";
import { ImgSlot } from "../components/site/ImgSlot";
import { useContent } from "../lib/content";

const ICONS = { smartphone: Smartphone, sparkles: Sparkles };

const Programs = () => {
  const { content } = useContent();
  return (
    <PageLayout title="Programs">
      <section className="relative pt-16 pb-10 overflow-hidden">
        <div className="ambient" aria-hidden />
        <div className="ambient-grid" aria-hidden />
        <div className="container-tt">
          <SectionHeading eyebrow="Programs" title="How TechTies shows up for seniors." description="TechTies workshops don't run on a fixed schedule — we visit senior centers as opportunities arise, and every visit is tailored to the people in the room. Our work falls into two programs." />
        </div>
      </section>

      <section className="py-14">
        <div className="container-tt space-y-16">
          {content.programs.map((p, i) => {
            const Icon = ICONS[p.icon] || Sparkles;
            const flipped = i % 2 === 1;
            return (
              <Reveal key={p.slug}>
                <article className="grid lg:grid-cols-12 gap-10 items-center" data-testid={`program-${p.slug}`}>
                  <div className={`lg:col-span-5 ${flipped ? "lg:order-2" : ""}`}>
                    <ImgSlot src={p.image} label={p.title} ratio="4/3" className="shadow-card" />
                  </div>
                  <div className={`lg:col-span-7 ${flipped ? "lg:order-1" : ""}`}>
                    <div className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-accent/70 border border-sky/15 text-skyDark"><Icon size={22} /></div>
                    <h3 className="font-display text-3xl md:text-4xl mt-6 text-stone">{p.title}</h3>
                    <p className="mt-5 text-lg text-stone/85 leading-relaxed">{p.summary}</p>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </section>
    </PageLayout>
  );
};

export default Programs;
